import React from 'react';
import { DisplayFlex, Content, BalanceValue  } from '../Pages/styles';
import formatter from '../../../utils/formatter';

const BalanceSummaryItem = props => {
	const { title, balanceSummaryValue } = props;
	const formatValue = () => {

		let formatedData = formatter({
			value: balanceSummaryValue,
			fieldSuffix: 'Dollars',
		});

		return ( balanceSummaryValue ? (
			Math.sign(balanceSummaryValue) === -1 ? `(${formatedData})` : formatedData
		): '$0.00')
	}

	return (
		<DisplayFlex>
			<Content>{ title }</Content>
			<BalanceValue MmarginRight="41px">
				{ formatValue() }
			</BalanceValue>
		</DisplayFlex>
	)
}

export default BalanceSummaryItem;